import { memo } from "react";
import Logo from "@/components/logo/Logo";
import UserInfo from "./UserInfo";
import { StyledContainer } from "./Header.styles";
import { useNavigate } from "@tanstack/react-router";

export interface HeaderProps {
  variant?: "primary" | "secondary";
  showUserInfo?: boolean;
}

const Header = ({ variant = "primary", showUserInfo = false }: HeaderProps) => {
  const navigate = useNavigate();

  const handleClickLogo = () => {
    navigate({ to: "/" });
  };

  return (
    <StyledContainer variant={variant}>
      <Logo
        color={variant === "primary" ? "white" : "green"}
        onClick={handleClickLogo}
      />
      {showUserInfo && <UserInfo />}
    </StyledContainer>
  );
};

export default memo(Header);
